// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal2_modal__3YNec"};